export default {
  term: {
    order: -1,
    format: (value: any) => `Term '${value}'`
  },
  category: {
    isMultiple: true,
    delimiter: '/',
    order: 0
  },
  files_included: {
    isMultiple: true,
    delimiter: ',',
    labels: {
      '.sketchplugin': '.sketchplugin',
      adjustmentpresets: 'AdjustmentPresets',
      'affinity designer': 'Affinity Designer',
      'ai illustrator': 'AI Illustrator',
      'coreldraw cdr': 'CorelDRAW CDR',
      'epub file': 'ePub File',
      'flat png': 'Flat PNG',
      font: 'Font',
      'google slides pptx': 'Google Slides PPTX',
      'high dynamic range hdr': 'High Dynamic Range HDR',
      'indesign indd': 'InDesign INDD',
      'quark qxp': 'Quark QXP',
      'jpg image': 'JPG Image',
      'keynote key': 'Keynote KEY',
      'layered png': 'Layered PNG',
      'layered psd': 'Layered PSD',
      lrplugin: 'LRPlugin',
      lrtemplate: 'LRTemplate',
      'opentype otf': 'OpenType OTF',
      'openexr image': 'OpenEXR Image',
      other: 'Other',
      pfm: 'PFM',
      'photoshop abr': 'Photoshop ABR',
      'photoshop grd': 'Photoshop GRD',
      'photoshop asl': 'Photoshop ASL',
      'photoshop atn': 'Photoshop ATN',
      'photoshop csh': 'Photoshop CSH',
      'photoshop hdr': 'Photoshop HDR',
      'photoshop jsx': 'Photoshop JSX',
      'photoshop pat': 'Photoshop PAT',
      'photoshop psd': 'Photoshop PSD',
      'powerpoint ppt': 'Powerpoint PPT',
      'powerpoint pptx': 'Powerpoint PPTX',
      'sketch file': 'Sketch File',
      'tga image': 'TGA Image',
      'theme thmx': 'Theme THMX',
      'tiff image': 'TIFF Image',
      'transparent png': 'Transparent PNG',
      'truetype ttf': 'TrueType TTF',
      'vector eps': 'Vector EPS',
      'zxp file': 'ZXP file',
      'n/a': 'Not available'
    },
    order: 1
  },
  tags: {
    isMultiple: true,
    delimiter: ',',
    order: 2
  },
  price_min: {
    inRangeWith: { max: 'price_max' },
    label: 'At least',
    format: (value: any) => `$${value}`,
    order: 3
  },
  price_max: {
    inRangeWith: { min: 'price_min' },
    label: 'At most',
    format: (value: any) => `$${value}`,
    order: 4
  },
  sales: {
    isMultiple: true,
    delimiter: ',',
    labels: {
      'rank-0': 'No sales',
      'rank-1': 'Low',
      'rank-2': 'Medium',
      'rank-3': 'High',
      'rank-4': 'Top Sellers'
    },
    order: 5
  },
  rating_min: {
    isMultiple: false,
    labels: {
      '': 'Show All',
      '1': '1 star and higher',
      '2': '2 stars and higher',
      '3': '3 stars and higher',
      '4': '4 stars and higher'
    },
    order: 6
  },
  sort_by: {
    isMultiple: false,
    labels: {
      relevance: 'Best match',
      trending: 'Trending items',
      sales: 'Best sellers',
      rating: 'Best rated',
      date: 'Newest items',
      'price-asc': 'Price: low to high',
      'price-desc': 'Price: high to low'
    },
    order: 7
  },
  date: {
    isMultiple: false,
    format: (value: string = 'Any date') => `Added ${value.toLowerCase()}`,
    labels: {
      '': 'Any date',
      'this-year': 'In the last year',
      'this-month': 'In the last month',
      'this-week': 'In the last week',
      'this-day': 'In the last day'
    },
    order: 8
  },
  date_updated: {
    isMultiple: false,
    format: (value: string = 'Any date') => `Updated ${value.toLowerCase()}`,
    labels: {
      '': 'Any date',
      'this-year': 'In the last year',
      'this-month': 'In the last month',
      'this-week': 'In the last week',
      'this-day': 'In the last day'
    },
    order: 9
  },
  platform: {
    isMultiple: false,
    delimiter: ' ',
    order: 10
  },
  compatible_with: {
    isMultiple: true,
    delimiter: ',',
    order: 11
  },
  attribute_value: {
    isMultiple: false,
    order: 12
  },
  poly_count: {
    isMultiple: false,
    order: 13,
    format: (label: any) => `${label} polygons`
  },
  file_formats: {
    isMultiple: true,
    isArrayFormat: true,
    delimiter: ',',
    order: 14,
    labels: {
      obj: '.obj (multi format)',
      fbx: '.fbx (multi format)',
      max: '.max (3ds Max)',
      c4d: '.c4d (cinema 4d)',
      ma: '.ma (maya)',
      blend: '.blend (blender)',
      '3ds': '.3ds (multi format)',
      mb: '.mb (maya)',
      lwo: '.lwo (lightwave)',
      dxf: '.dxf (multi format)',
      dwg: '.dwg (AutoCAD)',
      lws: '.lws (lightwave)',
      '3b': '.3b (3dcoat)',
      unitypackage: '.unitypackage (Unity3D)',
      vob: '.vob (Vue)',
      vue: '.vue (Vue)',
      ztl: '.ztl (zbrush)',
      xsi: '.xsi (softimage)',
      e3d: '.e3d (Instant3D)',
      lxo: '.lxo (Luxology modo)',
      hrc: '.hrc (softImage)'
    }
  },
  orientation: {
    isMultiple: false,
    labels: {
      '': 'Show All',
      landscape: 'Landscape',
      portrait: 'Portrait',
      square: 'Square'
    },
    order: 15
  },
  colors: {
    isMultiple: true,
    delimiter: ',',
    order: 16
  },
  sizes: {
    isMultiple: true,
    delimiter: ',',
    labels: {
      m: 'Medium',
      l: 'Large',
      xl: 'Extra large',
      xxl: 'Extra extra large'
    },
    order: 17
  },
  length_min: {
    inRangeWith: { max: 'length_max' },
    label: 'At least',
    order: 18
  },
  length_max: {
    inRangeWith: { min: 'length_min' },
    label: 'At most',
    order: 19
  },
  vocals_in_audio: {
    isMultiple: true,
    delimiter: ',',
    labels: {
      'background vocals/harmonies': 'Background Vocals',
      'instrumental version included': 'Instrumental Included'
    },
    order: 20
  },
  tempo: {
    isMultiple: false,
    labels: {
      'very-slow': 'Very slow (0 - 60 BPM)',
      slow: 'Slow (60 - 90 BPM)',
      medium: 'Medium (90 - 110 BPM)',
      upbeat: 'Upbeat (110 - 140 BPM)',
      fast: 'Fast (140 - 160 BPM)',
      'very-fast': 'Very fast (160+ BPM)'
    },
    order: 21
  },
  resolution_min: {
    isMultiple: false,
    labels: {
      '': 'Show all',
      '720p': '720p (HD)',
      '1080p': '1080p (Full HD)',
      '2K': '2K',
      '4K': '4K (UHD)'
    },
    order: 22
  },
  frame_rate: {
    isMultiple: false,
    shouldSort: true,
    labels: {
      '': 'Show All',
      '23.98': '23.98 fps',
      '24': '24 fps',
      '25': '25 fps',
      '29.97': '29.97 fps',
      '30': '30 fps',
      '50': '50 fps',
      '59.94': '59.94 fps',
      '60': '60 fps'
    },
    order: 23
  },
  requires_plugins: {
    isMultiple: false,
    format: (value: any) => `Requires Plugins: ${value}`,
    labels: {
      '': 'Show All',
      F: 'No',
      T: 'Yes'
    },
    order: 24
  },
  alpha: {
    isMultiple: false,
    isBoolean: true,
    labels: {
      1: 'Alpha channel'
    },
    order: 25
  },
  looped: {
    isMultiple: false,
    isBoolean: true,
    labels: {
      1: 'Looped'
    },
    order: 26
  },
  include_pro_affiliated: {
    labels: {
      true: 'Yes',
      false: 'No'
    },
    order: 27
  }
}
